module.exports = __webpack_public_path__ + "static/media/card-phone.d15808c2.png";